(function ($) {
  function initP3Swiper($root) {
    var $sliders = $root.find('#scenes_swiper');

    $sliders.each(function () {
      var el = this;
      var $el = $(el);

      // 多重初期化防止
      if ($el.data('initialized')) return;
      $el.data('initialized', true);

      new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 500,
        grabCursor: true,
        watchOverflow: true,
        centeredSlides: false,

        slidesOffsetBefore: 0,
        slidesOffsetAfter: 24,

        navigation: {
          nextEl: $el.find('.swiper__next')[0],
          prevEl: $el.find('.swiper__prev')[0]
        },

        breakpoints: {
          750: {
            spaceBetween: 48,
            slidesOffsetAfter: 40
          }
        }
      });
    });
  }

  // 通常ロード
  $(function () {
    initP3Swiper($(document));
  });

  // Shopify Theme Editor（セクション再描画）
  $(document).on('shopify:section:load', function (evt) {
    // loadされたセクションの中だけ初期化
    var $section = $('#shopify-section-' + evt.detail.sectionId);
    initP3Swiper($section.length ? $section : $(document));
  });

  // （任意）ブロック追加/並び替え時などに再初期化したい場合
  $(document).on('shopify:section:select shopify:block:select shopify:block:deselect', function (evt) {
    var $section = $('#shopify-section-' + evt.detail.sectionId);
    initP3Swiper($section.length ? $section : $(document));
  });

})(jQuery);

$(function () {
    $('.ac-parent').on('click', function () {
    $(this).next().slideToggle();
    $(this).toggleClass('open');
  });
});
// 2026-09-04: 「Makuakeでのご購入について」折りたたみを、FAQ内リンク(#sc-makuake)やURLハッシュから開く
$(function () {
  function openMakuakeBlock() {
    var $t = $('#sc-makuake .ac-parent');
    if (!$t.length || $t.hasClass('open')) return;
    $t.addClass('open').next().slideDown();
  }
  if (location.hash === '#sc-makuake') { openMakuakeBlock(); }
  $(document).on('click', 'a[href="#sc-makuake"]', function () { openMakuakeBlock(); });
});
